module.exports = __webpack_public_path__ + "static/media/LanternCityMarketEXTA0007_design_clean_v003.1af2533e.png";